import m from "../../geodata/es2015/sanMarinoHigh";
window.am4geodata_sanMarinoHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/sanMarinoHigh.js
// module id = null
// module chunks = 